import React from 'react';
import { Link } from 'react-router-dom';
import { ProjectBillingStatusDetail } from '../../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTurnDownLeft, faX } from '@fortawesome/pro-solid-svg-icons';
import sctheme from 'app/styles/sctheme';

const ProjectReference = ({ item, month, year }) => {
  const ReferenceStatus = ({ status, project }) => {
    switch (status) {
      case ProjectBillingStatusDetail.InAnotherBillingForGivenPeriod:
        return (
          <Link
            className="ml-3"
            style={{
              color: sctheme.blues.secondary,
              pointerEvents: 'auto'
            }}
            to={`/admin/invoices/${month}/${year}/${project.previousBillingId}`}
          >
            <span className="mr-1">
              <FontAwesomeIcon icon={faArrowTurnDownLeft} />
            </span>
            View in existing batch{' '}
          </Link>
        );
      case ProjectBillingStatusDetail.OtherBillingReferenceRemoved:
        return (
          <div
            className="ml-3"
            style={{
              color: sctheme.grays.$600
            }}
          >
            {' '}
            <span className="mr-1">
              <FontAwesomeIcon icon={faX} />
            </span>
            Removed from previous batch
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`p-3 project-info ${item.totalPreviouslyInvoicedProjects > 0 ? 'previous-invoiced' : ''}`}>
      <p className="mb-0 font-weight-bold" style={{ color: sctheme.black, textTransform: 'uppercase' }}>
        Projects
      </p>
      {item.projectDetails.map(project => {
        return (
          <div key={project.projectName}>
            <div style={{ color: sctheme.black }}>{project.projectName}</div>
            <ReferenceStatus status={project.status} project={project} />
          </div>
        );
      })}
    </div>
  );
};

export default ProjectReference;
